import { gql } from "@apollo/client";


//----- Supprimer un utilisateur
/*
 Exemple de variables
  {
    "id" : "/api/users/2"
  }
*/
export const DELETE_USER = gql`
mutation DeleteUser($id: ID!){
	deleteUser(input: {id:$id}){
    user{
      id
    }
  }  
}`;